const invalidEmail = 'E-post är ogiltigt';

const serviceEntry = 'Underhållsbesök';

const fi: LocaleType = {
  subtitle: (...args: string[]) => `${args[0]} is ${args[1]}`,
  cancel: 'Avbryt',
  login_button: 'Logga in',
  signout: 'Logga ut',
  loading: 'Snälla vänta',
  read_more: 'Läs mer',
  general: {
    countryNameFI: 'Finland',
    countryNameSE: 'Sverige',
  },
  auth: {
    successAuth: 'Autentiserats. Omdirigera till startsidan',
    processing: 'Bearbeta autentisering',
    invalidAuth: 'Ogiltig session för användaren.',
  },
  errors: {
    default: 'Den här begäran kunde inte levereras',
    duplicate: 'Data finns redan i systemet.',
    invalidEmail: invalidEmail,
    pageNotFound: 'Sidan hittas inte',
  },
  cookie: {
    message:
      'Denna webbplats använder cookies för att ge dig en bra användarupplevelse. Genom att fortsätta använda denna webbplats godkänner du användningen av cookies i enlighet med oss.',
    policy: 'Cookiepolicy',
    accept: 'Acceptera',
  },
  landing_page: {
    header: {
      user: {
        hey: (...args: string[]) => `Hej ${args[0]}, `,
        bookings: 'kolla dina egna bokningar här',
        check_bookings: 'Kolla dina bokningar',
        has_reservation: 'Har du redan en reservation? ',
      },
      menus: {
        home: 'Framsida',
        parks: 'Parker',
        bestpoint: 'BestPoint -serviceställe',
        why_bestpark: 'Varför BestPark?',
        our_story: 'Presentation',
        info: 'Info',
        for_host: 'För Värdar',
        the_cities: 'För Städer',
        contact_us: 'Kontakta oss',
        login: 'Logga in',
      },
      buy_tickets: 'Köp biljetter',
      buy: 'Köp',
      all_parks: 'Alla parker',
      make_reservation: 'Boka nu',
      for_host: 'För Värdar',
      demonstration: 'Presentation',
      the_cities: 'För Städer',
      the_press: 'För Pressen',
    },
    footer: {
      follow: 'Fölg oss',
      contact: 'Kontakter',
      quick_links: 'Snabblänkar',
      traveling: 'Resa med dig',
      other_links: 'Andra länkar',
      privacy_statement: 'Dataskyddsförklaring',
      terms_of_delivery: 'Leveransvillkor',
      see_map: 'Se på kartan',
      travel: 'Tillsammans på väg med dig',
      privacy: 'Dataskyddsförklaring',
      media: 'För Pressen',
    },
    hero: {
      title: 'Det bästa sättet att stanna!',
      text: 'Vi öppnar de sex första parkerna för sommarsäsongen 2020.',
      view_parks: 'Ta en titt på parkerna',
    },
  },
  park_info: {
    header: 'Välj ankomstdatum i kalendern',
    amenities: (...args: string[]) =>
      `${args[0]} platser och ${args[1]} bekvämligheten:`,
    faq: 'Vanliga frågor och svar',
    extras: {
      area: 'Område',
      forWhom: 'För vem',
      thingsToDo: 'Sevärdheter och aktiviteter',
    },
    intro: 'Presentation',
  },
  reservation: {
    noReservation: 'Inga reserveringar',
    continue: 'Forsätta',
    previous: 'Tidigare',
    loading: 'Snälla vänta',
    slots: {
      header: 'Hur många nätter stannar du?',
      arrival: (...args: string[]) => `Ditt ankomstdatum ${args[0]}.`,
      comment: (...args: string[]) =>
        `Eftersom nästa helg är slutsåld kan den maximala natten per vistelse vara ${args[0]}.`,
      choose: 'Välja parkplats här',
      chooseTitle: 'Välja din parkplats',
      unavailable: 'Otillgänglig',
      regularSlots: 'Vanliga platser',
      price: (...args: string[]) => `(Pris ${args[0]} ${args[1]}/natt)`,
      addPrice: (...args: string[]) => `(Pris +${args[0]} ${args[1]}/natt)`,
      slotError: (...args: string[]) =>
        `Slot ${args[0]} is no longer available. Select a new one.`,
    },
    coupon: {
      validateCoupon: 'Validera',
      couponCode: 'Kupongkod',
      couponInvalid: 'Kupong ogiltig',
      couponApplied: 'Kupong tillämpad',
      couponDiscount: 'Kupongrabatt',
      couponExpired: 'Den här kupongen har redan gått ut',
      invalidPark: 'Den här kupongen är inte giltig för den valda Parken',
      limitExceeded: 'Antalet användning av denna kupong är full',
      userLimitExceeded: 'Den här kupongen har redan använts',
      shortNights:
        'Den här kupongen är inte giltig för de valda antalet nätter',
      exceedingNights:
        'Den här kupongen är inte giltig för de valda antalet nätter',
    },
    registration: {
      header: 'Dina kontaktuppgifter',
      subheader: 'Befintliga BestPark konto?',
      login: 'Logga in här',
      loginNote: 'Logga in här',
      firstName: 'Förnamn',
      lastName: 'Efternamn',
      phone: 'Telefon',
      phoneInfo: 'Telefon (i internationellt format, e.g. +358401234567)',
      email: 'E-post',
      street: 'Adress',
      postalCode: 'Postnummer',
      town: 'Postkontor',
      country: 'Land',
      license: 'Dragfordons registreringsskylt',
      promos:
        'Registrera dig för vårt nyhetsbrev och bli den första som får de senaste nyheterna om BestPark.',
      errors: {
        fillRequired: 'Fyll i markerade fält',
        email: invalidEmail,
        phone:
          'Numret måste vara i internationellt format, till exempel +358401234567',
        emailExist: 'E-post är redan registrerad.',
        fieldRequired: 'Fältet är obligatoriskt',
      },
      clickHereToReserve: 'Klicka här för att starta din bokning',
    },
    payment: {
      header: 'Betalning',
      subheader: 'Välj betalningsmetod för att slutföra din bokning.',
      night: (...args: string[]) =>
        `${args[0]} ${parseInt(args[0]) > 1 ? 'Nätter' : 'Natt'} i parken`,
      total: 'Totala',
      totalInCurrency: (...args: string[]) => `Totalpris i ${args[0]}`,
      currencyConversionNote: (...args: string[]) =>
        `${args[0]} omräknat till ${args[1]} för betalning`,
      cardPay: 'Betala med kredit- och betalkort',
      mobilePay: 'Betala med mobila betalningar',
      collectorBankPay: 'Betala med faktura eller i batchar',
      invoicePayment: 'Betala med faktura',
      invoiceNote: (...args: string[]) =>
        `Tilläggsavgift för pedding av beloppet för ${args[0]} ${
          Number(args[0]) > 1 ? 'euros' : 'euro'
        }`,
      surcharge: 'tilläggsavgift',
      onlineBankPay: 'Betala i nätbanken',
      coupon: 'Har du en kupongkod?',
      terms1: 'Jag har läst och förstått',
      terms2: 'villkoren.',
      terms3:
        'Vi kommer också att skapa ett konto för dig för enklare användning av dina BestPark inköp.',
      pay: (...args: string[]) => `Betala ${args[0]} nu`,
      processingPayment: 'Behandling av bokningsbetalning',
      paymentProcessed: 'bearbetar betalning',
      paymentError:
        'Något gick fel! Vårt team kommer att undersöka detta. Du kan kontakta oss.',
      orderNumber: 'Order number: ',
      failed: 'Betalningstransaktionen avbruten',
    },
    card: {
      goToReservation: 'Gå till bokning',
      days: (...args: string[]) =>
        `${args[0]} ${parseInt(args[0]) > 1 ? 'Nätter' : 'Natt'}`,
    },
    profile: {
      header: 'Din bokning',
    },
    guestInformation: {
      header: 'Resandeanmälan',
      firstName: 'Förnamn',
      lastName: 'Efternamn',
      address: 'Adress',
      dateOfBirth: 'Födelsetid',
      nationality: 'Medborgarskap',
      passportNumber: 'Numret på pass',
      dateOfArrival: 'Ankomstdag',
      countryOfEntry: (...args: string[]) =>
        `Det land från vilket resandena anländer till ${args[0]}`,
      addChildButton: 'Lägg till familjemedlem',
      addPassenger: 'Lägg till ytterligare en passagerare',
      passengerInformation: 'Personuppgifter om resande',
      childSpouseInfo: 'Familjemedlemmen personliga uppgifter',
      passportInfo: (...args: string[]) =>
        `Ifylls inte av nordisk medborgare eller resande som är bosatt i ${args[0]}`,
      companionHeader:
        'Personuppgifter för make eller maka och minderåriga barn som följer med resanden',
      subHeader:
        'Lämnande av falska personuppgifter är straffbelagt enligt strafflagen.',
      delete: 'Radera',
    },
    ancillary: {
      header: 'Ytterligare tjänster',
      skip: 'Hoppa över dessa',
      subheader1: 'Håll dig på resande fot medan parkerade!',
      subheader2: 'Vi har elektriska skotrar och cyklar i alla parker',
      subheader3: 'Begränsade be antal per park så boka din i förväg idag!',
      soldOut: 'Tyvärr slutsåld för alla dagar av din vistelse.',
      soldOutDay: (...args: string[]) =>
        `Alla ${args[0]} är reserverade för denna dag`,
      price: (...args: string[]) => `${args[0]}€ per dygn`,
      reservation: 'Välj antal och datum:',
      max: (...args: string[]) => `Endast ${args[0]} tillgänglig för denna dag`,
      total: 'Totala:',
      totalService: (...args: string[]) =>
        `${args[0]} ${args[1]} on ${args[2]} ${
          parseInt(args[2]) > 1 ? 'Dagar' : 'Dygn'
        }`,
      firstDayNote: 'Bokningen börjar kl. 13:00 och slutar kl. 12:00 nästa dag',
      dayNote: 'Reservation starts at 12:00 and ends 12:00 next day',
      lastDayNote: 'Reservation starts at 12:00 and ends 12:00 next day',
    },
    details: {
      checkIn: 'Incheckning',
      checkOut: 'Utcheckning',
      info: (...args: string[]) =>
        `Incheckningstiden börjar ${args[0]} varje dag och utcheckningstiden är vid  ${args[1]}`,
      addOns: {
        earlyCheckIn: {
          info: 'Sen incheckning fram till kl. 13',
          button: (...args: string[]) => `Lägg till för ${args[0]}€`,
        },
        lateCheckOut: {
          info: ' Sen utcheckning kl 15:00',
          button: (...args: string[]) => `Lägg till för ${args[0]}€`,
        },
      },
      parking: {
        textSlot: 'Plats nummer',
        title: (...args: string[]) => `${args[0]}`,
        slot: (...args: string[]) =>
          `När du anländer till parken är din reserverade ${args[0]} ${args[1]}.`,
      },
      map: {
        button: 'Navigera till Parken',
      },
      general: {
        title: 'Porten öppnas',
        text:
          'När du anländer till parken, kan du öppna porten med denna personliga kod:',
        linkInfo: (...args: string[]) =>
          `Visa information om ${args[0]} BestPark`,
        linkModify: 'Behöver du ändra eller avboka den här bokningen?',
        linkDownload: 'Ladda ner ditt kvitto',
        add: 'Lägg till',
      },
      services: {
        title: (...args: string[]) => `Din ${args[0]}`,
        text: (...args: string[]) =>
          `Det kommer att ha instruktioner här om var du kan plocka upp ${args[0]} du har reserverat.`,
      },
      extendReservation: 'Förlänga din bokning',
      cancelReservation: 'Avboka bokning',
      cancelledReservation: 'Bokning avbokad',
    },
    confirmation: {
      confirmed: 'Bokningen bekräftad',
      pending: 'Reservation väntar för närvarande.',
      confirmed_message: (...args: string[]) =>
        `Tack för din bokning, vi ser fram emot att se dig i ${args[0]}.`,
    },
    errors: {
      cancel: 'Du kan avboka bokningen 7 dagar före ankomst',
    },
    success: {
      cancel: 'Bokningen har avbokats.',
    },
    receipt: {
      invoice: (...args: string[]) => `Receipt #${args[0]}`,
      header: (...args: string[]) =>
        `Tack för din betalning för bokning  ${args[0]},  det har betalats i sin helhet för beloppet ${args[1]} ${args[2]}`,
      details: {
        paymentDate: 'Betalningsdatum',
        contactEmail: 'Kontakta e-post',
        chargedTo: 'Debiteras till',
        chargedFree: 'Gratis',
        forReservation: 'För bokning',
      },
      breakdown: {
        park: 'Parken',
        couponUsed: 'Kupongkod',
        serviceEntry: serviceEntry,
        couponDiscount: (...args: string[]) => `Rabatt ${args[0]} ${args[1]}`,
        subtotal: 'Delsumma',
        grandTotal: 'Totalt pris (Inkl. MOMS)',
        taxNotes: 'MOMS',
        vat: (...args: string[]) => `${args[0]} ${args[1] ?? 10}%`,
      },
      businessId: 'Fo-nummer',
    },
    extension: {
      full_title: 'Reservationstillägget är inte tillgängligt',
      full_description: (...args: string[]) =>
        `Tyvärr kan din bokning inte längre förlängas av anledningen till att parkeringsplats ${args[0]} på ${args[1]} inte längre är tillgänglig.`,
      full_description2:
        'Du kanske vill boka igen för en annan parkplats på vår bokningssida.',
      book_reservation: 'Gör en ny bokning',
    },
  },
  promotions: {
    general: {
      read_more: 'Läs mer',
    },
    hotline: {
      title: 'Hjälptjänst 24/7',
      text: 'Vår kundtjänst är alltid tillgänglig',
      footer: 'Priset för ett samtal är 8,35 cent/samtal + 16,69 cent/minut',
    },
    infos: {
      title: 'Påverka!',
      text: 'Tips de bästa platserna och delta i presentkortdragningen.',
      buttonText: 'Till utfrågning',
    },
  },
  login: {
    header: 'Logga in på ditt konto',
    subheader: 'Inget konto ännu? ',
    registrationLink: 'Registrera dig här',
    forgetPasswordLink: 'Glömt lösenord?',
    email: 'E-Post',
    password: 'Lösenord',
    continue: 'Forsätta',
    authContent: 'Ange autentiseringskod som skickas till ',
    errors: {
      fillRequired: 'Fyll i markerade fält',
      email: 'E-post är ogiltigt',
      sessionInvalidated: 'Sessionen uplöpt, vänligen logga in igen',
      invalidCode: 'Ogiltig kod',
    },
  },
  mail: {
    header: 'Kontrollera din telefon',
    open: 'Öppna appen E-post',
    content: (...args: string[]) =>
      `Vi har skickat en inloggningslänk till ${args[0]} för att logga in dig.`,
  },
  registration: {
    header: 'Registrera ett konto',
    subheader: 'Befintliga BestPark konto? ',
    registerButton: 'Registrera',
    success: {
      header: 'Du har registrerat dig.',
      content: 'Du kan nu logga in på ditt konto.',
    },
  },
  profileEdit: {
    header: 'Redigera profilkonto',
    subheader: 'Uppdatera dina kontouppgifter',
    editButton: 'Redigera profil',
    success: {
      header: 'Du har uppdaterat ditt konto.',
      content: 'Kundkonto',
    },
  },
  book_category: {
    unavailable_title: (...args: string[]) =>
      `${args[0]} bokning är inte tillgänglig`,
    unavailable_description: 'Kanske du vill boka en RV plats.',
    book_reservation: 'Boka en husbilsparkering',
  },
  calendar: {
    general: {
      start_reservation: 'Starta reservationen',
      select_check_in: 'Välj incheckningsdatum.',
      select_check_out: 'Välj utcheckningsdatum och klicka på starta bokning.',
      select_extended_check_out: 'Välj utcheckningsdatum',
      extension_title: 'Förlänga din bokning',
      extension_description:
        'Du kan förlänga samma bokning för upp till 7 extra nätter',
      to_pay: 'Betala här',
      summary_extension: (...args: string[]) =>
        `Förlängning av bokningen med ${args[0]} nätter för totalt ${args[1]} ${args[2]}. Ny utcheckning till  ${args[3]} kl. 12:00.`,
      summary: (...args: string[]) =>
        `Reservation från ${args[0]} till ${args[1]}.\nChecka in kl. ${args[2]}, checka ut kl. ${args[3]}. Totalt pris: ${args[4]} ${args[5]}.`,
      cancellation_policy:
        'Gratis avbokning 2 dagar före ankomst. 50% återbetalning vid avbokning före kl. 13.00 på ankomstdagen.',
    },
    months: {
      january: 'Januari',
      february: 'Februari',
      march: 'Mars',
      april: 'April',
      may: 'Maj',
      june: 'Juni',
      july: 'Juli',
      august: 'Augusti',
      september: 'September',
      october: 'Oktober',
      november: 'November',
      december: 'December',
    },
    in_months: {
      january: 'Januari',
      february: 'Februari',
      march: 'Mars',
      april: 'April',
      may: 'Maj',
      june: 'Juni',
      july: 'Juli',
      august: 'Augusti',
      september: 'September',
      october: 'Oktober',
      november: 'November',
      december: 'December',
    },
    weeks: {
      monday: 'Mån',
      tuesday: 'Tis',
      wednesday: 'Ons',
      thursday: 'Tor',
      friday: 'Fre',
      saturday: 'Lör',
      sunday: 'Sön',
    },
  },
  parks: {
    from: 'Från',
    check_advance: 'Checka in i förväg',
    promotion: (...args: string[]) =>
      `Vi har ${args[0]} moderna parker för sommaren ${args[1]}`,
    per_night: 'per dygn',
    listTitle: (...args: string[]) => `Sommar ${args[0]} parken:`,
  },
  newsletter: {
    title: 'Beställ nyhetsbrev',
    subscribe: 'Beställ',
    subscribeMsg:
      'Prenumerera på vårt nyhetsbrev och bli först med att höra BestPark-nyheterna',
    notifications: {
      subscribeSuccess: 'Tack för att vi hör av dig!',
      subscribeError: 'Det gick inte att behandla din begäran. Försök igen.',
    },
  },
  mediaPage: {
    visualisation: 'Visuella bilder',
    stock: 'Illustrationer',
    parkImages: 'Fotogalleri',
  },
  contactUs: {
    billingHeader: 'Fakturadetalj',
    businessId: 'Organisationsnummer',
    paymentTerm: 'Betalningsvillkor',
    paymentTermValue: (term: string) => `${term} days`,
    invoiceAddress: 'E-fakturaadress',
    brokerAddress: 'Förmedlarens adress',
    send: 'Skicka',
  },
  formLabels: {
    message: 'Ditt meddelande',
    name: 'Namn',
    email: 'E-post',
    place: 'Plats',
    authCode: 'Autentiseringskod',
  },
  serviceEntry: {
    card: {
      header: 'I behov av underhåll?',
      subheader1:
        'Gör ett depåstopp på din resa hos oss! Du får en kod som är giltig i 60 minuter från din ankomst til parken.',
      subheader2: 'Du kan göra besöket mellan klockan 7 och 22.',
      cta: (...args: string[]) => `Besöket kostar ${args[0]} ${args[1]}.`,
    },
    selectDate: {
      header: 'Välj datum för underhållsbesök',
      cta: 'Gå vidare till kontaktuppgifter',
      reminder:
        'Lösenkoden gäller i 60 minuter från aktivering vid p-platsens port.',
    },
    confirmation: {
      paymentProcessed: 'bearbetar betalning',
    },
    summary: {
      buttonText: 'Visa underhållsbesok',
      dayInPark: serviceEntry,
    },
    details: {
      date: 'Tid för underhållsbesöket',
      listHeader: serviceEntry,
    },
  },
  book: {
    header: (...args: string[]) => `Boka en plats för\n ${args[0]} BestPark`,
    headerCategory: (...args: string[]) =>
      `Boka en ${args[0]} för\n ${args[1]} BestPark`,
    maintenanceHeader: (...args: string[]) =>
      `Boka underhåll hos\n ${args[0]} BestPark`,
  },
};

export default fi;
